module.exports = __webpack_public_path__ + "static/palitaw-sa-latik-3624599087bc6cfdea3f3b48a111a948.jpg";